import { render, staticRenderFns } from "./GroupItemInput.vue?vue&type=template&id=b274c034&scoped=true&"
import script from "./GroupItemInput.vue?vue&type=script&lang=js&"
export * from "./GroupItemInput.vue?vue&type=script&lang=js&"
import style0 from "./GroupItemInput.vue?vue&type=style&index=0&id=b274c034&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b274c034",
  null
  
)

export default component.exports